var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2564 3.43017C9.2087 1.68358 6.00001 1.55021 3.77412 3.12935C1.57112 4.69227 1.03977 7.42065 2.46432 9.52754C2.55377 9.65983 2.5766 9.8262 2.5261 9.97769L1.91964 11.7971L4.26052 11.299C4.37234 11.2752 4.48891 11.2894 4.59175 11.3393C7.10522 12.5596 10.2331 11.924 11.8979 9.90435C13.5395 7.91267 13.2799 5.15604 11.2564 3.43017ZM3.17968 2.29147C5.78348 0.444208 9.51212 0.592114 11.9231 2.64854C14.3584 4.72567 14.7011 8.1187 12.6906 10.5578C10.74 12.9243 7.1874 13.6494 4.30541 12.3398L1.25534 12.9887C1.07514 13.0271 0.888213 12.966 0.765445 12.8286C0.642678 12.6913 0.602876 12.4987 0.661135 12.3239L1.4736 9.8865C-0.105466 7.31879 0.625316 4.10365 3.17968 2.29147ZM4.57288 6.49339C4.85657 6.49339 5.08655 6.72337 5.08655 7.00706V7.01391C5.08655 7.2976 4.85657 7.52757 4.57288 7.52757C4.28919 7.52757 4.05922 7.2976 4.05922 7.01391V7.00706C4.05922 6.72337 4.28919 6.49339 4.57288 6.49339ZM7.31244 6.49339C7.59613 6.49339 7.8261 6.72337 7.8261 7.00706V7.01391C7.8261 7.2976 7.59613 7.52757 7.31244 7.52757C7.02875 7.52757 6.79877 7.2976 6.79877 7.01391V7.00706C6.79877 6.72337 7.02875 6.49339 7.31244 6.49339ZM10.052 6.49339C10.3357 6.49339 10.5657 6.72337 10.5657 7.00706V7.01391C10.5657 7.2976 10.3357 7.52757 10.052 7.52757C9.7683 7.52757 9.53833 7.2976 9.53833 7.01391V7.00706C9.53833 6.72337 9.7683 6.49339 10.052 6.49339Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewMessage);
export default __webpack_public_path__ + "static/media/new-message.76ebd88f39c16f5847921bf5677aca8f.svg";
export { ForwardRef as ReactComponent };